import React from 'react';

const TaraCard = ({ 
  variant = 'default',
  interactive = false,
  glowing = false,
  children,
  className = '',
  ...props 
}) => {
  const variants = {
    default: 'bg-white',
    cosmic: 'bg-gradient-to-br from-cosmic-50 to-white',
    sacred: 'bg-gradient-to-br from-sacred-50 to-white',
  }
  
  return (
    <div
      className={`
        ${variants[variant]}
        ${interactive ? 'cursor-pointer hover:shadow-card-hover active:scale-[0.98] transition-all duration-300' : ''}
        ${glowing ? 'shadow-cosmic' : 'shadow-card'}
        ${className}
        rounded-card p-6
      `}
      {...props}
    >
      {children}
    </div>
  )
}

const TaraCardHeader = ({ children, className = '' }) => (
  <div className={`mb-4 ${className}`}>{children}</div>
)

const TaraCardTitle = ({ children, className = '' }) => (
  <h3 className={`font-serif text-xl md:text-2xl font-medium text-stone-900 ${className}`}>
    {children}
  </h3>
)

const TaraCardDescription = ({ children, className = '' }) => (
  <p className={`text-sm text-stone-600 leading-relaxed mt-1 ${className}`}>
    {children}
  </p>
)

const TaraCardContent = ({ children, className = '' }) => (
  <div className={`space-y-4 ${className}`}>{children}</div>
)

export { TaraCard, TaraCardHeader, TaraCardTitle, TaraCardDescription, TaraCardContent };